<rl-view-item
  [areAnnotationsResolved]="areAnnotationsResolved$ | async"
  [currentCitation]="itemCitation$ | async"
  [currentUserPermissions]="currentUser.permissions"
  [depth]="depth"
  [isExpanded]="isExpanded$ | async"
  [isSubscribedToResource]="isSubscribedToResource$ | async"
  [item]="item$ | async"
  [itemId]="itemId"
  [listId]="listId"
  [onlineResource]="onlineResource$ | async"
  [pageContent]="pageContent$ | async"
  [readingIntention]="readingIntention$ | async"
  [showCitation]="showCitation$ | async"
  [studyNote]="studyNote$ | async"
  [user]="currentUser.oauthUser"
  (checkResourceSubscription)="onCheckResourceSubscription($event)"
  (forceLogin)="onForceLogin()"
  (listItemClick)="onListItemClickAction($event)"
  (listItemView)="onListItemView($event)"
  (readingIntentionUpdate)="onReadingIntentionUpdate($event)"
  (readingIntentionDelete)="onReadingIntentionDelete($event)"
  (showShareSheet)="onShowShareSheet($event)"
  (studyNoteUpdate)="onStudyNoteUpdate($event)"
  (studyNoteDelete)="onStudyNoteDelete($event)"
  (subscribeToResource)="onSubscribeToResource($event)"
  (toggleExpanded)="onToggleExpanded($event)"
  (changeDimension)="onDimensionChange($event)"
  (onlineResourceClick)="onOnlineResourceClick($event)"
  (showReportBrokenLinkModal)="onShowReportBrokenLinkModal($event)"
>
</rl-view-item>
